"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var positionMap = {
    static: 'static',
    relative: 'relative',
    fixed: 'fixed',
    absolute: 'absolute',
    sticky: 'sticky',
};
exports.default = (function (_a) {
    var position = _a.position;
    return (position in positionMap ? "position: " + positionMap[position] + ";" : '');
});
